import { render, staticRenderFns } from "./ListDetail.vue?vue&type=template&id=213be4b2&scoped=true&"
import script from "./ListDetail.vue?vue&type=script&lang=js&"
export * from "./ListDetail.vue?vue&type=script&lang=js&"
import style0 from "./ListDetail.vue?vue&type=style&index=0&id=213be4b2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213be4b2",
  null
  
)

/* custom blocks */
import block0 from "./ListDetail.vue?vue&type=custom&index=0&blockType=i18nf"
if (typeof block0 === 'function') block0(component)

export default component.exports